import React from 'react';

const Toast = ({ toast, onDismiss }) => {
  const getIcon = () => {
    switch (toast.type) {
      case 'success':
        return '✓';
      case 'error':
        return '✕';
      case 'warning':
        return '⚠';
      case 'info':
      default:
        return 'ℹ';
    }
  };

  const getColor = () => {
    switch (toast.type) {
      case 'success':
        return 'var(--success)';
      case 'error':
        return 'var(--danger)';
      case 'warning':
        return 'var(--warning)';
      case 'info':
      default:
        return 'var(--accent)';
    }
  };

  const getBackgroundColor = () => {
    switch (toast.type) {
      case 'success':
        return 'rgba(16, 185, 129, 0.2)';
      case 'error':
        return 'rgba(239, 68, 68, 0.2)';
      case 'warning':
        return 'rgba(234, 179, 8, 0.2)';
      case 'info':
      default:
        return 'var(--bgSecondary)';
    }
  };

  return (
    <div
      className="glass"
      style={{
        border: `1px solid color-mix(in srgb, ${getColor()} 25%, transparent)`,
        borderRadius: '12px',
        padding: '12px 16px',
        marginBottom: '10px',
        minWidth: 'min(300px, calc(100vw - 40px))',
        maxWidth: 'min(400px, calc(100vw - 40px))',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.3)',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        animation: 'slideInDown 0.25s ease-out',
        position: 'relative',
        zIndex: 10000
      }}
    >
      <div
        style={{
          width: '24px',
          height: '24px',
          borderRadius: '50%',
          background: getBackgroundColor(),
          color: getColor(),
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 'bold',
          fontSize: '14px',
          flexShrink: 0
        }}
      >
        {getIcon()}
      </div>
      <div style={{ flex: 1, color: 'var(--textPrimary)', fontSize: '14px', lineHeight: '1.4' }}>
        {toast.message}
      </div>
      <button
        onClick={() => onDismiss(toast.id)}
        style={{
          background: 'transparent',
          border: 'none',
          color: 'var(--textSecondary)',
          cursor: 'pointer',
          fontSize: '18px',
          padding: '0',
          width: '20px',
          height: '20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexShrink: 0,
          transition: 'color 0.2s'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.color = 'var(--textPrimary)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.color = 'var(--textSecondary)';
        }}
      >
        ×
      </button>
      <style>{`
        @keyframes slideInDown {
          from {
            transform: translateY(-12px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
      `}</style>
    </div>
  );
};

export const ToastContainer = ({ toasts, onDismiss }) => {
  return (
    <div
      style={{
        // Top-centre, under the weather bar: the right edge is where the map's
        // control panels (Mission Controller, Map Controls) sit, and toasts
        // stacked there covered ARM / START.
        position: 'fixed',
        top: 'calc(var(--m-inset-top, 0px) + 64px)', // phone: below the top bar
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 10000,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        pointerEvents: 'none'
      }}
    >
      {toasts.map(toast => (
        <div
          key={toast.id}
          style={{ pointerEvents: 'auto' }}
        >
          <Toast toast={toast} onDismiss={onDismiss} />
        </div>
      ))}
    </div>
  );
};

export default Toast;
